import React from 'react';
import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { DigitalQuestion, PartialBy, QuestionCaseSetting } from '../../../redux/types';

export type MutableQuestionCaseSetting = QuestionCaseSetting & {
  changed?: boolean;
}

type Props = {
  selectedSectionId?: number;
  contextQuestions: DigitalQuestion[];
  settingsByCtxQuestionsId?: Record<number, PartialBy<MutableQuestionCaseSetting, 'id'|'digitalCaseId'>>;
  onChangeSettings: React.Dispatch<React.SetStateAction<Record<number, PartialBy<MutableQuestionCaseSetting, 'id' | 'digitalCaseId'>> | undefined>>
};

const ContextQuestionEditSettings = ({
  selectedSectionId,
  contextQuestions,
  settingsByCtxQuestionsId,
  onChangeSettings,
}: Props) => {
  const checkHandler = (cq: DigitalQuestion, status: boolean, property: keyof Pick<MutableQuestionCaseSetting, 'compulsory'>) => {
    const existingSetting = settingsByCtxQuestionsId?.[cq.id];
    if (existingSetting) {
      const newMap: Record<number, PartialBy<MutableQuestionCaseSetting, 'id'|'digitalCaseId'>> = {
        ...settingsByCtxQuestionsId,
        [cq.id]: {
          ...existingSetting,
          [property]: status,
          changed: true,
        },
      };
      onChangeSettings(newMap);
    } else if (selectedSectionId) {
      const newMap: Record<number, PartialBy<MutableQuestionCaseSetting, 'id'|'digitalCaseId'>> = {
        ...settingsByCtxQuestionsId,
        [cq.id]: {
          digitalQuestionId: cq.id,
          digitalSectionId: cq.digitalSectionId || selectedSectionId,
          digitalSurveyId: cq.digitalSurveyId,
          [property]: status,
          changed: true,
        },
      };
      onChangeSettings(newMap);
    }
  };

  return (
    <List>
      {
        contextQuestions.map((cq) => (
          <ListItem
            key={cq.id}
            secondaryAction={(
              <Box display="flex" gap={1} alignItems="center">
                <Chip label={cq.type} />
                <FormControlLabel
                  label={<FormattedMessage id="questioneditor.required" />}
                  control={(
                    <Checkbox
                      onChange={(e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => { checkHandler(cq, checked, 'compulsory'); }}
                      checked={settingsByCtxQuestionsId?.[cq.id]?.compulsory || false}
                      inputProps={{ 'aria-labelledby': `checkbox-${cq.id}` }}
                    />
                  )}
                />
              </Box>
            )}
          >
            <ListItemText primary={cq.text} />
          </ListItem>
        ))
      }
    </List>
  );
};

export default ContextQuestionEditSettings;
